import React, { useContext, useEffect, useState } from "react";
import * as yup from "yup";
import ApiActions from "api_actions";
import MyToast from "components/toast/toast";

import { Formik, Form, Field, ErrorMessage } from "formik";

import styles from "./bottom_tab.module.css";
import { BookingDataContext } from "containers/data_context";
import { Button, Col, Nav, Row } from "react-bootstrap";
import PolicyCheckbox from "components/payment_form/submit_booking_button/policy_checkbox";
import { BookOutlined, LogoutOutlined, UserOutlined } from "@ant-design/icons";
import UserBookings from "components/user_bookings";

const UserInfo = ({ open, setOpen, userInfo }) => {
  const { channelId } = useContext(BookingDataContext);
  const [showUserBooking, setShowUserBooking] = useState(false);

  return (
    <div className={`${styles.bottom_sheet} ${open ? styles.show : ""}`}>
      <div className={styles.sheet_content}>
        {showUserBooking && (
          <UserBookings
            showModal={showUserBooking}
            userData={userInfo}
            setShowModal={() => {
              setShowUserBooking(false);
              setOpen(false);
            }}
            channelId={channelId}
          />
        )}
        <div className={styles.user_info}>
          <div className={`${styles.name} ${styles.option}`}>
            <UserOutlined className="mr-1 " />{" "}
            <div>
              {userInfo?.name}
              <sup className={styles.memberBadge}>{userInfo?.login_type}</sup>
            </div>
          </div>

          <div className={styles.option} onClick={() => setShowUserBooking(true)}>
            <BookOutlined className="mr-1" /> My Bookings
          </div>

          <div
            className={`${styles.option} ${styles.logout}`}
            onClick={() => {
              localStorage.removeItem("userInfo");
              window.location.reload();
            }}
          >
            <LogoutOutlined className="mr-1" /> Logout
          </div>
        </div>
      </div>
    </div>
  );
};
export default UserInfo;
